import { useParams } from 'react-router-dom';
import { CompanyDepartmentsPage } from '../CompanyDepartmentsPage';

export const CompanyDepartment = () => {
	const { id } = useParams<{ id: string }>();
	return <CompanyDepartmentsPage companyId={id} />;
};
